module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('v-layout', {
    staticClass: "align-items-center login-body-container",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('div', {
    staticClass: "login-body"
  }, [_c('div', {
    staticClass: "form-header"
  }, [_c('img', {
    staticClass: "app-logo",
    attrs: {
      "src": "/static/img/logo-clerkinn-use.png",
      "alt": "logo-clerkinn"
    }
  })]), _vm._v(" "), _c('v-form', {
    staticClass: "form-body",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": 'Correo electrónico',
      "single-line": "",
      "rules": _vm.emailRules,
      "prepend-icon": "mail_outline",
      "append-icon": _vm.validateEmail(_vm.model.email) ? 'check' : '',
      "append-icon-cb": function () { return (_vm.model.email = !_vm.model.email); },
      "required": ""
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.model.email = $$v
      },
      expression: "model.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": 'Contraseña',
      "single-line": "",
      "rules": _vm.passwordRules,
      "prepend-icon": "vpn_key",
      "append-icon": _vm.model.password ? 'check' : '',
      "append-icon-cb": function () { return (_vm.model.password = !_vm.model.password); },
      "type": 'password',
      "required": ""
    },
    model: {
      value: (_vm.model.password),
      callback: function($$v) {
        _vm.model.password = $$v
      },
      expression: "model.password"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "remember-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-flex-end": "",
      "align-items-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "label-check",
    attrs: {
      "xs11": "",
      "text-xs-right": ""
    }
  }, [_vm._v("Recordar mis datos")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "success",
      "append-icon": _vm.rememberLogin ? 'check_circle' : 'radio_button_unchecked',
      "append-icon-cb": function () { return (_vm.rememberLogin = !_vm.rememberLogin); },
      "hide-details": ""
    },
    model: {
      value: (_vm.rememberLogin),
      callback: function($$v) {
        _vm.rememberLogin = $$v
      },
      expression: "rememberLogin"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-4": ""
    }
  }, [_c('v-btn', {
    staticClass: "button-login",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading,
      "loading": _vm.loading
    }
  }, [_vm._v("\n\t\t\t\t\t\tIngresar\n\t\t\t\t\t")])], 1)], 1)], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticClass: "align-items-center login-footer",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-left": ""
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Privacidad")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Términos y condiciones")])], 1)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pr-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.languages,
      "box": true,
      "hide-details": ""
    },
    model: {
      value: (_vm.currentLanguage),
      callback: function($$v) {
        _vm.currentLanguage = $$v
      },
      expression: "currentLanguage"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-013ee0ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 725
// module chunks = 108